module.exports = __webpack_public_path__ + "img/71.7.Chla.57a70284.png";